module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('b', [_vm._v("A NOTE ON TIMING")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("This book, the first of four comprising the story “A Handful of Men,” follows as a sequel to "), _c('i', [_vm._v("Emperor and Clown,")]), _vm._v(" which was itself the fourth and final part of “A Man of His Word.” It is not necessary to have read the earlier series in order to appreciate this one (although of course I hope you will read and enjoy both).")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("No dates were recorded in “A Man of His Word,” because history had little interest for the humble folk of Krasnegar. When required to make reference to a particular year, they normally counted from the accession of their current monarch, a system that would have no meaning for outsiders. As far as the Impire was concerned, the events reported ran from the late spring of 2979 to the fall of 2981. Detailed narrative begins in this volume with the Battle of Karthin, early in 2997, a little more than fifteen years later.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Such Imperial dates were counted from Emine’s founding of the Protocol, the system that for almost three millennia had controlled the political use of sorcery. Without the Protocol, the world would have collapsed into the sort of chaos it had known during the War of the Five Warlocks, or the Dragon Wars, or even the Dark Times …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c79263","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 78
// module chunks = 0